import { AddSvg } from "./AddSvg";
import { BasketSvg } from "./BasketSvg";
import { CameraSvg } from "./CameraSvg";
import { CheckSvg } from "./CheckSvg";
import { CopySvg } from "./CopySvg";
import { EyeOffSvg } from "./EyeOffSvg";
import { FaceBookSvg } from "./FaceBookSvg";
import { FilterSvg } from "./FilterSvg";
import { GiftSvg } from "./GiftSvg";
import { GoBackSvg } from "./GoBackSvg";
import { GoogleSvg } from "./GoogleSvg";
import { HeaderBasketSvg } from "./HeaderBasketSvg";
import { HeartBigSvg } from "./HeartBigSvg";
import { HeartSvg } from "./HeartSvg";
import { KeySvg } from "./KeySvg";
import { MailSvg } from "./MailSvg";
import { MapSvg } from "./MapSvg";
import { MinusSvg } from "./MinusSvg";
import { NotificationCheckSvg } from "./NotificationCheckSvg";
import { PhoneSvg } from "./PhoneSvg";
import { PlusSvg } from "./PlusSvg";
import { RememberCheckSvg } from "./RememberCheckSvg";
import { RemoveSvg } from "./RemoveSvg";
import { RightArrowSvg } from "./RightArrowSvg";
import { SearchSvg } from "./SearchSvg";
import { StatusCheckSvg } from "./StatusCheckSvg";
import { BellTabSvg } from "./tabs/BellTabSvg";
import { TagSvg } from "./TagSvg";
import { TwitterSvg } from "./TwitterSvg";
import { UserSvg } from "./UserSvg";
import { ViewAllSvg } from "./ViewAllSvg";

import { BirthDay } from "./BirthDay";
import { CloseSvg } from "./CloseSvg";
import { Gender } from "./Gender";
import { LineSvg } from "./LineSvg";
import { HeartTabSvg } from "./tabs/HeartTabSvg";
import { HomeTabSvg } from "./tabs/HomeTabSvg";
import { MenuTabSvg } from "./tabs/MenuTabSvg";
import { ProfileSvg } from "./tabs/ProfileSvg";
import { RedeemSvg } from "./tabs/RedeemSvg";
import { SearchTabSvg } from "./tabs/SearchTabSvg";
import { StoreSvg } from "./tabs/StoreSvg";
import { OrderTabSvg } from "./tabs/OrderTabSvg";
import { LoginSvg } from "./LoginSvg";

export const svg = {
  KeySvg,
  MapSvg,
  AddSvg,
  TagSvg,
  GiftSvg,
  UserSvg,
  PlusSvg,
  MailSvg,
  CopySvg,
  HeartSvg,
  MinusSvg,
  CheckSvg,
  PhoneSvg,
  SearchSvg,
  FilterSvg,
  BasketSvg,
  CloseSvg,
  RemoveSvg,
  GoogleSvg,
  CameraSvg,
  EyeOffSvg,
  GoBackSvg,
  ViewAllSvg,
  HomeTabSvg,
  TwitterSvg,
  ProfileSvg,
  BellTabSvg,
  FaceBookSvg,
  HeartTabSvg,
  HeartBigSvg,
  SearchTabSvg,
  RightArrowSvg,
  StatusCheckSvg,
  HeaderBasketSvg,
  RememberCheckSvg,
  NotificationCheckSvg,
  BirthDay,
  Gender,
  MenuTabSvg,
  LineSvg,
  StoreSvg,
  RedeemSvg,
  OrderTabSvg,
  LoginSvg
};
